import { gql } from '@apollo/client';

export const DELETE_STORY_ANALYSIS_MUTATION = gql`
    mutation deleteStoryAnalysis($id: String!, $draftId: String!, $userId: String!) {
        deleteStoryAnalysis(id: $id, draftId: $draftId, userId: $userId)
    }
`;
